import { render } from "./loader-talents.vue?vue&type=template&id=15b8b38a&ts=true"
import script from "./loader-talents.vue?vue&type=script&lang=ts"
export * from "./loader-talents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__